module.exports = __webpack_public_path__ + "img/salud.9b5edc01.jpeg";